module.exports = __webpack_public_path__ + "static/media/icon-ok.6b9c8328.svg";